import PropTypes from 'prop-types';

import TextareaField from 'components/Fields/TextareaField/TextareaField';
import SelectField from 'components/Fields/SelectField/SelectField';
import {
  withFullTranslationKey,
  CLAIM_DETAILS,
  CONTENT_DETAILS,
  OPTIONS_CLAIM_COPYRIGHT_TYPE,
  OPTIONS_CLAIM_COPYRIGHT_TYPE_LIST,
} from 'components/ContentReporting/ContentLegalReporting/content-legal-reporting-config';
import { OPTIONS_CONTENT_TYPE, USE_LABEL_FROM_TRANSLATION_PREFIX } from 'components/ContentReporting/shared-constants';
import { getFieldValid, getFieldValue } from 'components/ContentReporting/form-utils';
import { hasFeatureFlag, FEATURE_FLAGS } from 'components/ContentReporting/feature-flags';

const getCopyrightTypeOptions = contentType => {
  switch (contentType) {
    case OPTIONS_CONTENT_TYPE.PODCAST:
      return OPTIONS_CLAIM_COPYRIGHT_TYPE_LIST;
    case OPTIONS_CONTENT_TYPE.ARTIST_VIDEO_AUDIO:
      return OPTIONS_CLAIM_COPYRIGHT_TYPE_LIST.filter(
        type => type !== OPTIONS_CLAIM_COPYRIGHT_TYPE.VIDEO && type !== OPTIONS_CLAIM_COPYRIGHT_TYPE.IMAGE,
      );
    default:
      return OPTIONS_CLAIM_COPYRIGHT_TYPE_LIST.filter(type => type !== OPTIONS_CLAIM_COPYRIGHT_TYPE.VIDEO);
  }
};

const CopyrightContentTypeFields = ({
  formData,
  handleFieldChange,
  forceValidation,
  shouldDisplayTypeSelection,
  t,
  enabledFeatureFlags,
}) => {
  const fieldValue = getFieldValue(formData);
  const fieldValidValue = getFieldValid(formData);
  const isFeatureFlagEnabled = hasFeatureFlag(enabledFeatureFlags);
  const copyrightInfoLabelOverride = isFeatureFlagEnabled(FEATURE_FLAGS.UMG)
    ? CLAIM_DETAILS.labels.CLAIM_COPYRIGHT_INFO_UMG
    : CLAIM_DETAILS.labels.CLAIM_COPYRIGHT_INFO;

  const contentType = fieldValue(CONTENT_DETAILS.fields.REPORTED_CONTENT_TYPE);

  return (
    <>
      {shouldDisplayTypeSelection && (
        <SelectField
          field={{
            name: CLAIM_DETAILS.fields.CLAIM_COPYRIGHT,
            type: 'text',
            options: getCopyrightTypeOptions(contentType),
            labelOverride: USE_LABEL_FROM_TRANSLATION_PREFIX,
            required: true,
          }}
          hasDefaultPlaceholder
          value={fieldValue(CLAIM_DETAILS.fields.CLAIM_COPYRIGHT)}
          valid={fieldValidValue(CLAIM_DETAILS.fields.CLAIM_COPYRIGHT)}
          tPrefix={withFullTranslationKey(CLAIM_DETAILS.translationPrefixes.CLAIM_COPYRIGHT)}
          onFieldChange={handleFieldChange}
          forceValidation={forceValidation}
        />
      )}

      <TextareaField
        field={{
          name: CLAIM_DETAILS.fields.CLAIM_COPYRIGHT_INFO,
          type: 'text',
          maxlength: 20000,
          labelOverride: t(copyrightInfoLabelOverride),
          required: true,
        }}
        value={fieldValue(CLAIM_DETAILS.fields.CLAIM_COPYRIGHT_INFO)}
        onFieldChange={handleFieldChange}
      />
    </>
  );
};

CopyrightContentTypeFields.propTypes = {
  formData: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
  forceValidation: PropTypes.bool.isRequired,
  shouldDisplayTypeSelection: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  enabledFeatureFlags: PropTypes.instanceOf(Set).isRequired,
};

export default CopyrightContentTypeFields;
